var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M445.6,256c0,59.3,0.1,118.6,0,177.8c0,30.3-18.1,54.9-46.2,62.6c-5.6,1.5-11.7,2.3-17.5,2.4 c-84.2,0.1-168.3,0.1-252.5,0.1c-34.6,0-61.7-26-63.6-60.5c-0.1-2-0.1-4-0.1-5.9c0-87.9,0-175.9,0-263.8c0-12.4,2-24.4,8.9-34.9 c3.8-5.7,8.7-10.7,13.6-15.4c19.9-19.4,40.1-38.5,60.2-57.7C159.5,49.9,170.4,39,182,28.7C193.3,18.6,206.8,13,222.3,13 c53.3,0.1,106.5,0,159.8,0c34.1,0,61.2,25.7,63.3,59.7c0.2,2.6,0.2,5.3,0.2,7.9C445.6,139.1,445.6,197.6,445.6,256z M241.6,244.3 c0-13.8,0.1-27.7,0-41.5c-0.1-10-5.4-14.4-15.2-13.1c-1.1,0.2-2.3,0.3-3.4,0.6c-48.8,10.2-82.3,47.2-87.9,97 c-5.1,45.3,22.3,91.6,64.7,109c63.2,26,135.4-12.7,149.9-80.4c2.4-11.1-2.7-17.4-14.1-17.5c-26.1,0-52.3,0-78.4,0 c-10.9,0-15.4-4.6-15.5-15.7C241.6,269.9,241.6,257.1,241.6,244.3z M334.8,256C334.8,256,334.8,256,334.8,256 c14.1,0,28.2,0.1,42.4-0.1c7.2-0.1,10.5-4.7,8.8-11.4c-0.8-3.2-1.5-6.4-2.1-9.6c-7.6-42.9-44.3-78.9-87.4-85.5 c-10.5-1.6-16.5,3.4-16.5,13.9c-0.1,26.2-0.1,52.3,0,78.5c0,9.2,5.1,14.2,14.4,14.2C307.9,256,321.4,256,334.8,256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.e0dd58bf28f5461109fcb13c04304ebc.svg";
export { ForwardRef as ReactComponent };